import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import {
  DemandeContact,
  DemandeContactList,
  DemandeContactListAPI,
} from '../models/demandeContact';
import { Patient } from '../models/patient';

@Injectable({
  providedIn: 'root',
})
export class DemandeContactService {
  private readonly http = inject(HttpClient);
  readonly authService = inject(AuthService);

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getToken(),
    });
  }

  pull(): Observable<DemandeContactList> {
    const headers = this.getHeaders();

    return this.http
      .get<any>(`${environment.api.gateway}demandes-contact`, { headers })
      .pipe(
        map((retourAPI: DemandeContactListAPI) =>
          DemandeContactList.factory(retourAPI),
        ),
      );
  }

  push(demandeContact: DemandeContact): Observable<DemandeContact> {
    const headers = this.getHeaders();

    return this.http
      .post<any>(
        `${environment.api.gateway}demandes-contact`,
        demandeContact.toApi(),
        {
          headers,
        },
      )
      .pipe(map((retourAPI: any) => demandeContact));
  }

  pdf(id: number): Observable<Blob> {
    const headers = this.getHeaders();

    return this.http.get(
      `${environment.api.gateway}demandes-contact/${id}/pdf`,
      {
        headers: headers,
        responseType: 'blob',
      },
    );
  }
}
